module.exports = __webpack_public_path__ + "img/hot.56765401.png";